import { LucideIcon } from "lucide-react";
import clsx from "clsx";

type Tone = "info" | "success" | "warning" | "danger" | "neutral";
const TONE: Record<Tone, string> = {
  info:    "from-brand-500/10 to-brand-500/0 text-brand-700",
  success: "from-success-500/15 to-success-500/0 text-success-700",
  warning: "from-warning-500/15 to-warning-500/0 text-warning-700",
  danger:  "from-danger-500/15 to-danger-500/0 text-danger-700",
  neutral: "from-surface-200/60 to-surface-200/0 text-surface-700",
};

export function StatsCard({
  icon: Icon, label, value, hint, tone = "neutral",
}: {
  icon: LucideIcon;
  label: string;
  value: React.ReactNode;
  hint?: string;
  tone?: Tone;
}) {
  return (
    <div className="relative overflow-hidden card-elevated p-5">
      <div className={clsx("absolute -top-8 -right-8 w-32 h-32 rounded-full bg-gradient-to-br opacity-70 blur-2xl", TONE[tone])} />
      <div className="relative">
        <div className={clsx("inline-flex items-center justify-center h-9 w-9 rounded-lg bg-surface-100", TONE[tone].split(" ").pop())}>
          <Icon className="h-4.5 w-4.5" />
        </div>
        <div className="mt-4 text-2xs font-semibold uppercase tracking-wide text-surface-500">{label}</div>
        <div className="mt-1 text-2xl font-bold text-surface-900">{value}</div>
        {hint && <div className="mt-0.5 text-xs text-surface-500">{hint}</div>}
      </div>
    </div>
  );
}
